import { Flex, Button, Tooltip } from '@chakra-ui/react';
import { useCampaigns } from '../context/CampaignsContext';

const CampaignsTopSection = () => {
  const {
    selectedCampaigns,
    loaders: { isTableLoading, isCreateEditLoading },
    companiesIdCache,
    handleCreateModalOpen,
    handleDeleteCampaigns,
  } = useCampaigns();

  return (
    <Flex px="25px" mb="20px" align="center" gap="24px">
      <Button
        variant="blue"
        onClick={handleCreateModalOpen}
        disabled={!Object.keys(companiesIdCache)?.length}
      >
        הוספת קמפיינים
      </Button>

      <Tooltip label={!selectedCampaigns?.length ? 'נא לבחור קמפיינים' : ''}>
        <span>
          <Button
            variant="red"
            onClick={handleDeleteCampaigns}
            isDisabled={!selectedCampaigns?.length}
            isLoading={isTableLoading || isCreateEditLoading}
          >
            מחיקת קמפיינים
          </Button>
        </span>
      </Tooltip>
    </Flex>
  );
};

export default CampaignsTopSection;
